import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import StoreStyle from '../../../assets/stylesheets/store/StorePage.module.css';
import StoreCardList from "../StoreCardList";

import Apple from '../../../assets/img/sample/Apple.jpg';
import Tomato from '../../../assets/img/sample/Tomato.jpg';
import Egg from '../../../assets/img/sample/Egg.jpg';
import Bread from '../../../assets/img/sample/Bread.jpg';
import Steak from '../../../assets/img/sample/Steak.jpg';
import Croissants from '../../../assets/img/sample/Croissants.jpg';

const DEALS_ITEMS = [
  { id: 'deal-1', name: 'Honeycrisp Apples',   price: '$3.99/lb',     info: 'Save 20% • Peak season',  discount: 20, img: Apple },
  { id: 'deal-2', name: 'Heirloom Tomatoes',   price: '$2.79/lb',     info: 'Save 20% • Vine-ripened', discount: 20, img: Tomato },
  { id: 'deal-3', name: 'Sourdough Bread',     price: '$5.20',        info: 'Bundle: 2 for $9.99',     discount: 15, img: Bread },
  { id: 'deal-4', name: 'Free-range Eggs',     price: '$4.79/dozen',  info: 'Save $1.20 • Local farm', discount: 20, img: Egg },
  { id: 'deal-5', name: 'Grass-fed Steak',     price: '$15.99/lb',    info: 'Weekly special',          discount: 10, img: Steak },
  { id: 'deal-6', name: 'Butter Croissants',   price: '$3.99',        info: 'Buy 3 get 1 free',        discount: 25, img: Croissants },
];

export default function DealsOfWeek({ title = 'Deals items', to }) {
  const LIMIT = 6;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 300);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className={StoreStyle['featured-section']}>
      <div className={StoreStyle['featured-header']}>
        <h2 style={{ fontSize: 22, margin: 0 }}>{title}</h2>
        {to ? <Link to={to} style={{ color: '#16a34a', fontWeight: 600 }}>See all</Link> : null}
      </div>

      <div className={StoreStyle['swiper-rail']}>
        <StoreCardList
          items={DEALS_ITEMS}
          loading={loading}
          onBuy={(item) => console.log('Buy clicked:', item)}
          skeletonCount={LIMIT}
          showDiscountBadge
        />
      </div>
    </section>
  );
}